// import { Create, List, DetailCreate, Result, DetailList, DetailEdit } from "../Components";

export default [
    {
        path: "/training/written/list",
        component: () => import("./List.vue"),
        name: "training-written-list",
        meta: {
            requiresAuth: true,
        },
    },

    // {
    //     path: "/training/written/detail-list",
    //     component: DetailList,
    //     name: "training-written-detail-list",
    //     meta: {
    //         requiresAuth: true,
    //     },
    // },

    // {
    //     path: "/training/written/detail",
    //     component: DetailCreate,
    //     name: "training-written-detail",
    //     meta: {
    //         requiresAuth: true,
    //     },
    // },

    // {
    //     path: "/training/written/detail-edit/:id",
    //     component: DetailEdit,
    //     name: "training-written-detail-edit",
    //     meta: {
    //         requiresAuth: true,
    //     },
    // },

    // {
    //     path: "/training/written/result",
    //     component: Result,
    //     name: "training-written-result",
    //     meta: {
    //         requiresAuth: true,
    //     },
    // },

    {
        path: "/training/written/create",
        component: () => import("./Create.vue"),
        name: "training-written-create",
        meta: {
            requiresAuth: true,
        },
    },
];
